"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CACHE_EXPIRATION_IN_MILLIS = exports.SPLIT_TO_GOOGLE_ANALYTICS = exports.GOOGLE_ANALYTICS_TO_SPLIT = void 0;
// Integration types
exports.GOOGLE_ANALYTICS_TO_SPLIT = 'GOOGLE_ANALYTICS_TO_SPLIT';
exports.SPLIT_TO_GOOGLE_ANALYTICS = 'SPLIT_TO_GOOGLE_ANALYTICS';
// This value might be eventually set via a config parameter
exports.DEFAULT_CACHE_EXPIRATION_IN_MILLIS = 864000000; // 10 days
